angular.module("app").service("cropperService", [
    'Cropper',
    '$timeout',
    function (Cropper, $timeout) {
        return function () {
            var scope = this,
                watchers = [],
                file,
                data,
                pagePristineImageDataUri;

            this.cropper = {};
            this.cropperProxy = 'cropper.first';
            this.options = {
                maximize: true,
                crop: function(dataNew) {
                    data = dataNew;
                }
            };
            this.showEvent = 'show';
            this.hideEvent = 'hide';

            this.load = function (file, fileDataUrl) {
                $timeout(function () {
                    scope.draggedImage = file;
                    scope.draggedImageDataUrl = fileDataUrl;
                    pagePristineImageDataUri = fileDataUrl;
                })
            };

            this.onFile = function (file) {
                $timeout(function () {
                    scope.draggedImage = file;
                })
            };

            this.preview = function(cb) {
                if (!file || !data) {
                    return cb();
                }
                Cropper.crop(file, data).then(Cropper.encode).then(function(dataUrl) {
                    cb(dataUrl);
                });
            };

            this.clear = function(degrees) {
                if (!scope.cropper.first) return;
                scope.cropper.first('clear');
            };

            this.scale = function(width) {
                Cropper.crop(file, data)
                    .then(function(blob) {
                        return Cropper.scale(blob, {width: width});
                    })
                    .then(Cropper.encode).then(function(dataUrl) {
                        (scope.preview || (scope.preview = {})).dataUrl = dataUrl;
                    });
            };

            this.$on("$destroy", function () {
                    var i = 0;
                    while(watchers[i]) {
                        watchers[i]();
                        i++;
                    }
                });

            function handleImageLoad (newVal) {
                $timeout(function () {
                    hideCropper();
                    Cropper.encode((file = newVal)).then(function (dataUrl) {
                        scope.newImageUploaded =(pagePristineImageDataUri != dataUrl);
                        scope.dataUrl = dataUrl;
                        scope.imageToLoad = undefined;
                        $timeout(showCropper);  // wait for $digest to set image's src
                    });
                }, 24)
            }

            function showCropper() { scope.$broadcast(scope.showEvent); }

            function hideCropper() { scope.$broadcast(scope.hideEvent); }

            watchers.push(scope.$watch('draggedImage', function (newVal) {
                if (!!newVal) {
                    handleImageLoad(newVal);
                } else {
                    data =  newVal
                }
            }));
        }
    }
]);






